module.exports = __webpack_public_path__ + "img/1474903717.201fcc56.jpg";